import React from 'react';

import ProductEditor from './product-editor';

const { UI, Order } = Mobi2Go;

Order.onReady(() => {
    let product_editor;
    let product_instance;

    const modal = UI.ExternalModal.create(
        'product-editor',
        <ProductEditor
            closeModal={retain_overlay => {
                modal.close(retain_overlay);
            }}
            scrollModalElementIntoView={(...args) =>
                modal.scrollElementIntoView(...args)
            }
            ref={component => {
                product_editor = component;
            }}
        />,
        {
            'data-view': 'product-editor',
            className: 'm2g-product-editor',
            fixedHeight: true,
        }
    );

    modal.setOnBeforeCloseHook(() => {
        let allow_modal_to_close = true;
        if (product_instance.isInOrder()) {
            const unmet_selection_requirement = product_instance.getUnmetSelectionRequirementModifierGroup();
            if (unmet_selection_requirement) {
                product_editor.groupSelectionRequirementWarning(
                    unmet_selection_requirement
                );
                allow_modal_to_close = false;
            }
        }
        return allow_modal_to_close;
    });

    modal.mount();

    UI.bind('editProduct', product => {
        product_instance = product;
        if (product_editor) {
            product_editor.setProduct(product_instance);
        }
        const element = document.querySelector('[data-view="product-editor"]');
        element.setAttribute(
            'data-product-name',
            product.menu_product.backend_name
        );
        element.setAttribute(
            'data-large-selection-of-modifiers',
            product.modifiers.length > 10
        );

        element.setAttribute('data-tags', product.menu_product.tags.join(' '));

        modal.open();
    });
});
